<!--
    Desarrollado por: Ing Wuilmer Garcia
    // Fecha:2023-10-11
    // Modificado por:
    // Fecha de ultima Modificacion:
    // Modificado por: 
    // Causa: 

-->

<template>
    <div>
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>


        <!-- Formulario control  de venta  -->
        <v-form ref="formDatos" lazy-validation> 
            <v-card>
                
                <v-divider></v-divider>

                <v-card-text>
                    <v-row class="pt-3">

                        <v-col cols="12" sm="4" md="3" class="py-0">
                            <v-text-field v-model="Datos.num_doc_venta" ref="" label="Correlativo de venta" dense
                                type="number" :rules="[validation.required]"
                                prepend-icon="fa-school" required>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12"  sm="4" md="3" class="py-0">
                            <v-radio-group v-model="Datos.view_existence" ref="" label="Ver existencia" row dense>
                                <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                <v-radio :label="`No`" :value="false" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12"  sm="4" md="3" class="py-0">
                            <v-radio-group v-model="Datos.view_costo" ref="" label="Ver costos" row dense>
                                <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                <v-radio :label="`No`" :value="false" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>


                        <v-col cols="12"  sm="4" md="3" class="py-0">
                            <v-radio-group v-model="Datos.view_zona" ref="" label="Ver zona" row dense>
                                <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                <v-radio :label="`No`" :value="false" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>



                        <v-col cols="12"  sm="4" md="3" class="py-0">
                            <v-radio-group v-model="Datos.incluye_impuesto" ref="" label="Incluye impuesto" row dense>
                                <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                <v-radio :label="`No`" :value="false" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12"  sm="4" md="3" class="py-0">
                            <v-radio-group v-model="Datos.reference_create" ref="" label="ver referencia" row dense >
                                <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                <v-radio :label="`No`" :value="false" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12" sm="4" md="3" class="py-0">
                            <v-text-field v-model="Datos.reference_desc" ref="" label="Descripción referencia" dense
                                :rules="[validation.required]" required>
                            </v-text-field>
                        </v-col>

                        
                        <v-col cols="12"  sm="4" md="4" class="py-0">
                            <v-radio-group v-model="Datos.almacen_default" ref="" label="Almacén por defecto" row dense>
                                <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                <v-radio :label="`No`" :value="false" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12" sm="4" md="2" class="py-0">
                            <v-select v-model="Datos.id_almacen_default" ref="" label="Almacen por defecto" dense
                                :items="listAlmacen" item-value="id" item-text="desc_almacen"
                                 :rules="[validation.selectReq]"> 
                            </v-select>
                        </v-col>


                        <v-col cols="12"  sm="4" md="4" class="py-0">
                            <v-radio-group v-model="Datos.zona_default" ref="" label="Zona por defecto" row dense>
                                <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                <v-radio :label="`No`" :value="false" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12" sm="4" md="2" class="py-0">
                            <v-select v-model="Datos.id_zona_default" ref="" label="Zona por defecto" dense
                                :items="listZona" item-value="id" item-text="desc_zona"
                                :rules="[validation.selectReq]"> 
                            </v-select>
                        </v-col>
                        
                        <v-col cols="12"  sm="4" md="4" class="py-0">
                            <v-radio-group v-model="Datos.transporte_default" ref="" label="Transporte por defecto" row dense>
                                <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                <v-radio :label="`No`" :value="false" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12" sm="4" md="2" class="py-0">
                            <v-select v-model="Datos.id_transporte_default" ref="" label="Transporte por defecto" dense
                                :items="listTransporte" item-value="id" item-text="desc_transporte"
                                :rules="[validation.selectReq]"> 
                            </v-select>
                        </v-col>
                        
                        <v-col cols="12"  sm="4" md="4" class="py-0">
                            <v-radio-group v-model="Datos.moneda_default" ref="" label="Moneda" row dense>
                                <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                <v-radio :label="`No`" :value="false" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12" sm="4" md="2" class="py-0">
                            <v-select v-model="Datos.id_moneda_default" ref="" label="Moneda por defecto" dense
                                :items="listMoneda" item-value="id" item-text="desc_moneda"
                                :rules="[validation.selectReq]"> 
                            </v-select>
                        </v-col>

                        
                        <v-col cols="12"  sm="4" md="4" class="py-0">
                            <v-radio-group v-model="Datos.producto_default" ref="" label="Producto por defecto" row dense>
                                <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                <v-radio :label="`No`" :value="false" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>


                        <v-col cols="12" sm="4" md="2" class="py-0">
                            <v-select v-model="Datos.id_producto_default" ref="" label="Producto por defecto" dense
                                :items="listProducto" item-value="id" item-text="desc_producto"
                                :rules="[validation.selectReq]"> 
                            </v-select>
                        </v-col>

                      
                        
                        <v-col cols="12"  sm="6" md="4" class="py-0">
                            <v-radio-group v-model="Datos.restringir_venta_sin_stock" ref="" label="Restringir venta sin stock" row dense>
                                <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                <v-radio :label="`No`" :value="false" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12"  sm="4" md="3" class="py-0">
                            <v-radio-group v-model="Datos.pago_cuenta" ref="" label="Agregar pago a cuenta" row dense>
                                <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                <v-radio :label="`No`" :value="false" color="error"></v-radio>
                            </v-radio-group>
                        </v-col>


                        <v-col cols="12" sm="4" md="3" class="py-0">
                            <v-select v-model="Datos.id_condicion_pago" ref="" label="Condicion de pago" dense
                                :items="listCondicionPago" item-value="id" item-text="desc_condicion_pago"
                                prepend-icon="fa-flag" :rules="[validation.selectReq]"> 
                            </v-select>
                        </v-col>
                        
                        <v-col cols="12" sm="4" md="3" class="py-0">
                            <v-select v-model="Datos.id_venta_estado_default" ref="" label="Status default" dense
                                :items="listEstado" item-value="id" item-text="desc_estado"
                                prepend-icon="fa-flag" :rules="[validation.selectReq]"> 
                            </v-select>
                        </v-col>
                    </v-row>        

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="btn_style3" tile @click="$emit('close')">Cancelar</v-btn>
                    <v-btn class="btn_block_style2" tile @click="saveItem">{{saveText}}</v-btn>
                </v-card-actions>

                <span v-if="test">

                    <code>Datos:  {{Datos}} </code> <br>
                    <code>Session Empresa: {{JSON.stringify(session.id_empresa)}}</code>
                    <code>Session Empresa: {{JSON.stringify(session.nombre_sucursal)}}</code>
                    <code> Session sucursal: {{JSON.stringify(session.id_sucursal)}}</code>
                    <code>Session load_sucursal: {{JSON.stringify(session.load_sucursal)}}</code>                    

                    <!--
                        <code>Datos Session {{JSON.stringify(session)}}</code>
                        <code>parametros :{{parametros}} </code> 
                    -->
                </span>
            </v-card>               
           
        </v-form>
    </div>

</template>



<script>
    import axios,  { API_URL } from '@/helpers/axios';
    import { validation } from "@/helpers/validator.js";
    import {mapMutations, mapGetters, mapActions} from 'vuex';
 

    export default {
        name:"ControlVenta",

        props:{
            parametros:{
                type:Object
            },
            estadoComp:{
                type:Boolean
            },
        },
        
        
        mounted() {
            this.loadMain()
        },

        created(){},


        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente:{"id_modulo": 11,  'id_submodulo':100}, //sud_modulo y modulo
            session: sessionStorage, // variables de sesion del usuario
            ////////////////////////////////////////////////////////
            //// CONSULTA PRINCIPAL
            search: '',            
            rutaServer: `${API_URL}`,
          
            Datos: {},
            test:false,      
            saveText : "Guardar Cambios",   
            listAlmacen:[],
            listTransporte: [],
            listZona: [],
            listMoneda: [],
            listCondicionPago: [],
            listEstado: [],
            listProducto: [],
          
            

        }),


        //computadas
        computed: {
            ...mapGetters('login', [ 'componenteEvento']),

            validation() {
                return validation;
            },

        },

        watch: {             
             // cada vez que la estado, esta función será ejecutada
            estadoComp() {
                if(this.estadoComp){
                    this.loadMain()                    
                }else{   
                    //this.parametros = {}
                    this.limpiarForm()

                }
            }
        },

        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////
           
             //-- cargar Parametros de inicio del componente --
            async loadMain(){

                this.limpiarForm() 
                this.getQuery()

            },

             //-------mostrar registros------------
            async getQuery(){
                try{
                    console.log(`controlVenta getQuery`)
                    // let params ={id_empresa: this.session.id_empresa }

                if (!this.session.id_sucursal) {
                    this.setEnviarMens({tipo:"W", mensaje: `Error en selecionar sucursal`, tiempo:null})
                    return 
                }

                    let response = await axios.get(`/sistema/configuracion/venta/empresa/${this.session.id_empresa}/sucursal/${this.session.id_sucursal}`)
                    this.listAlmacen    = response.data.Almacen
                    this.listEstado     = response.data.Estado  
                    this.listTransporte = response.data.Transporte
                    this.listZona       = response.data.Zona
                    this.listMoneda     = response.data.Moneda
                    this.listCondicionPago= response.data.CondicionPago
                    this.listProducto    = response.data.Producto
                    this.listEstado      = response.data.Estado  
                    

                    if(response.data.VentaConfig){
                        this.Datos          = response.data.VentaConfig
                    }
                    
                }
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }
                
           },


           
            // Guarda CONTROL VENTA
            async saveItem(){
                if (!this.$refs.formDatos.validate()) {
                    this.setEnviarMens({tipo:"W", mensaje: `Debe Ingresar todos los campos requeridos en el Formulario`, tiempo:null})
                    return 
                }

                if (!this.session.id_sucursal) {
                    this.setEnviarMens({tipo:"W", mensaje: `Error en selecionar sucursal`, tiempo:null})
                    return 
                }
                this.Datos.id_sucursal = this.session.id_sucursal
                try{    
                    let params = {venta:this.Datos}
                    let res = await axios.put(`/sistema/configuracion/venta/empresa/${this.session.id_empresa}`,params)
                    // this.$emit('reloadComp','empresa')
                    // this.$emit('close')
                    this.setEnviarMens({tipo:`${res.data.messageT}`, mensaje: `${res.data.message}`, tiempo:6000})
                    
                }   

                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }            

            },


            async limpiarForm(){               
                      
                this.$refs.formDatos.resetValidation()

                this.Datos = {
                                id:null, id_usuario: this.session.id, id_empresa : this.session.id_empresa, id_sucursal: this.session.id_sucursal,
                                num_doc_venta:'', view_existence:null,  view_costo:null, view_zona:null,
                                incluye_impuesto: null,reference_create:false, reference_desc:null,
                                id_almacen_default:null, almacen_default:false, id_transporte_default:null, transporte_default:false,
                                id_zona_default:null, zona_default: false, id_moneda_default:null, moneda_default:false,
                                producto_default:false,  id_producto_default:null,
                                restringir_venta_sin_stock:null, pago_cuenta:null, id_condicion_pago:null,   id_venta_estado_default:null                                    
                }       

            },


            // Validar resetear campos al guardar
            resetValidation() {
                this.$refs.formDatos.resetValidation()
            },



          

        },

    }
</script>



<style scoped>

 
</style>